import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, Scale, User, Megaphone, Download, ArrowRight } from 'lucide-react';
export function GuardrailExamples() {
  const guardrails = [{
    icon: User,
    title: 'Executive Ghostwriting (C-Suite Comms)',
    category: 'Enterprise Communications',
    description: 'Captures the distinct voice, strategic priorities, and decision-making frameworks of senior executives—including their preferred metaphors, risk tolerance, and stakeholder approaches that separate seasoned leadership from generic corporate speak.'
  }, {
    icon: Scale,
    title: 'Investment Thesis Reasoning (Private Equity)',
    category: 'Financial Services',
    description: 'Encodes the pattern recognition of experienced investors—market timing intuition, red flags in financials, competitive moat assessment, and the unwritten rules about when to walk away that separate top funds from average returns.'
  }, {
    icon: Shield,
    title: 'Clinical Judgment Protocols (Specialist Physicians)',
    category: 'Healthcare & Life Sciences',
    description: 'Preserves the diagnostic reasoning of top specialists—symptom pattern recognition, when to override protocols, patient communication for difficult conversations, and expertise that distinguishes veteran practitioners from textbook medicine.'
  }, {
    icon: Megaphone,
    title: 'Regulatory Navigation Expertise (Compliance)',
    category: 'Regulated Industries',
    description: 'Captures how senior compliance officers interpret gray areas—risk appetite calibration, enforcement trend awareness, regulator relationship management, and the institutional knowledge that keeps companies compliant without grinding operations to a halt.'
  }];
  return;
}